import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "favourite",
  "use": "favourite-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol viewBox=\"0 0 22 22\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"favourite\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M11 0a1 1 0 0 1 .897.557l2.857 5.79 6.39.934a1 1 0 0 1 .554 1.705l-4.623 4.503 1.09 6.362a1 1 0 0 1-1.45 1.054L11 17.9l-5.715 3.005a1 1 0 0 1-1.45-1.054l1.09-6.362L.303 8.986a1 1 0 0 1 .553-1.705l6.39-.935L10.104.557A1 1 0 0 1 11 0zm0 3.26L8.807 7.702a1 1 0 0 1-.752.546l-4.907.718 3.55 3.457a1 1 0 0 1 .288.885l-.838 4.883 4.387-2.307a1 1 0 0 1 .93 0l4.387 2.307-.838-4.883a1 1 0 0 1 .288-.885l3.55-3.457-4.907-.718a1 1 0 0 1-.752-.546L11 3.259z\" fill=\"#702F73\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./icons/favourite.svg
// module id = 452
// module chunks = 0